module.exports = __webpack_public_path__ + "img/tm.d4c2df68.svg";